// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/corps/layout10_bg2.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/images/corps/hanyang-guri.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/images/corps/samsung.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/images/corps/react.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/public/images/corps/sangaebaek.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/public/images/corps/seoul.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/public/images/corps/kangdongkyunghee.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("/public/images/corps/kangdongsungsim.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* div {
  border: 1px solid black;
} */
 
.section10_container__0GeW\\+ {
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
}

.section10_top__1yepi {
  text-align: center;           /* 텍스트 중앙 정렬 */  
}

.section10_text-top-1__n6wNg {
  color: black;
  font-size: 20px;
  font-weight: 1000;
  margin-bottom: -10px;
}

.section10_text-top-2__ONhCN {
  color: black;
  font-size: 13px;
}


.section10_grid-container__PTExz {
  display: grid;
  gap: 15px;
  /* 기본값: 화면이 좁을 때 (4행 × 2열) */
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(4, auto);
  
}
/* 개별 아이템 스타일 */
.section10_grid-item__rv\\+-6 {
  padding: 50px;
  object-fit: fill;
  background-position: center;
  background-size: 80%;
  background-repeat: no-repeat;
}

.section10_grid-item1__C-yk\\+ {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
 
}
.section10_grid-item2__iQ52p {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
 
}
.section10_grid-item3__HYmZC {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
 
}
.section10_grid-item4__eTpIG {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
 
}
.section10_grid-item5__PnOuJ {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
 
}
.section10_grid-item6__6RPE0 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
 
}
.section10_grid-item7__Fzqh7 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
 
}
/* .grid-item8 {
  background-image: url('/public/images/corps/');
} */


/* 화면이 좁을 때: 4행 × 2열 */
@media (max-width: 1024px) {
  .section10_grid-container__PTExz {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(4, auto);
    width:100%;
  }

  /* 개별 아이템 스타일 */
  .section10_grid-item__rv\\+-6 {
    margin: 2%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }
}


/* 화면이 넓을 때: 2행 × 4열 */
@media (min-width: 1025px) {
  .section10_container__0GeW\\+ {
    padding : 4%;
  }
  .section10_grid-container__PTExz {
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(2, auto);
    width:80%;
    padding-top: 1%;
    gap: 30px;
  }

  /* 개별 아이템 스타일 */
  .section10_grid-item__rv\\+-6 {
    margin: 5%;

    background-position: left;
    background-repeat: no-repeat;
    background-size: contain;
  }

  .section10_text-top-1__n6wNg {
    font-size: 30px;
  }
  
  .section10_text-top-2__ONhCN {
    font-size: 20px;
  }


}`, "",{"version":3,"sources":["webpack://./src/Sections/section10.module.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,yDAA8D;EAC9D,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB,YAAY,cAAc;AAC9C;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,SAAS;EACT,4BAA4B;EAC5B,qCAAqC;EACrC,mCAAmC;;AAErC;AACA,eAAe;AACf;EACE,aAAa;EACb,gBAAgB;EAChB,2BAA2B;EAC3B,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,yDAA8D;;AAEhE;AACA;EACE,yDAAyD;;AAE3D;AACA;EACE,yDAAuD;;AAEzD;AACA;EACE,yDAA4D;;AAE9D;AACA;EACE,yDAAuD;;AAEzD;AACA;EACE,yDAAkE;;AAEpE;AACA;EACE,yDAAiE;;AAEnE;AACA;;GAEG;;;AAGH,sBAAsB;AACtB;EACE;IACE,qCAAqC;IACrC,mCAAmC;IACnC,UAAU;EACZ;;EAEA,eAAe;EACf;IACE,UAAU;IACV,2BAA2B;IAC3B,4BAA4B;IAC5B,wBAAwB;EAC1B;AACF;;;AAGA,sBAAsB;AACtB;EACE;IACE,YAAY;EACd;EACA;IACE,qCAAqC;IACrC,mCAAmC;IACnC,SAAS;IACT,eAAe;IACf,SAAS;EACX;;EAEA,eAAe;EACf;IACE,UAAU;;IAEV,yBAAyB;IACzB,4BAA4B;IAC5B,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;;AAGF","sourcesContent":["/* div {\n  border: 1px solid black;\n} */\n \n.container {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n  background-image: url('/public/images/corps/layout10_bg2.jpg');\n  background-size: cover;\n  background-position: center;\n}\n\n.top {\n  text-align: center;           /* 텍스트 중앙 정렬 */  \n}\n\n.text-top-1 {\n  color: black;\n  font-size: 20px;\n  font-weight: 1000;\n  margin-bottom: -10px;\n}\n\n.text-top-2 {\n  color: black;\n  font-size: 13px;\n}\n\n\n.grid-container {\n  display: grid;\n  gap: 15px;\n  /* 기본값: 화면이 좁을 때 (4행 × 2열) */\n  grid-template-columns: repeat(2, 1fr);\n  grid-template-rows: repeat(4, auto);\n  \n}\n/* 개별 아이템 스타일 */\n.grid-item {\n  padding: 50px;\n  object-fit: fill;\n  background-position: center;\n  background-size: 80%;\n  background-repeat: no-repeat;\n}\n\n.grid-item1 {\n  background-image: url('/public/images/corps/hanyang-guri.png');\n \n}\n.grid-item2 {\n  background-image: url('/public/images/corps/samsung.png');\n \n}\n.grid-item3 {\n  background-image: url('/public/images/corps/react.png');\n \n}\n.grid-item4 {\n  background-image: url('/public/images/corps/sangaebaek.png');\n \n}\n.grid-item5 {\n  background-image: url('/public/images/corps/seoul.png');\n \n}\n.grid-item6 {\n  background-image: url('/public/images/corps/kangdongkyunghee.png');\n \n}\n.grid-item7 {\n  background-image: url('/public/images/corps/kangdongsungsim.png');\n \n}\n/* .grid-item8 {\n  background-image: url('/public/images/corps/');\n} */\n\n\n/* 화면이 좁을 때: 4행 × 2열 */\n@media (max-width: 1024px) {\n  .grid-container {\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: repeat(4, auto);\n    width:100%;\n  }\n\n  /* 개별 아이템 스타일 */\n  .grid-item {\n    margin: 2%;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n  }\n}\n\n\n/* 화면이 넓을 때: 2행 × 4열 */\n@media (min-width: 1025px) {\n  .container {\n    padding : 4%;\n  }\n  .grid-container {\n    grid-template-columns: repeat(4, 1fr);\n    grid-template-rows: repeat(2, auto);\n    width:80%;\n    padding-top: 1%;\n    gap: 30px;\n  }\n\n  /* 개별 아이템 스타일 */\n  .grid-item {\n    margin: 5%;\n\n    background-position: left;\n    background-repeat: no-repeat;\n    background-size: contain;\n  }\n\n  .text-top-1 {\n    font-size: 30px;\n  }\n  \n  .text-top-2 {\n    font-size: 20px;\n  }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `section10_container__0GeW+`,
	"top": `section10_top__1yepi`,
	"text-top-1": `section10_text-top-1__n6wNg`,
	"text-top-2": `section10_text-top-2__ONhCN`,
	"grid-container": `section10_grid-container__PTExz`,
	"grid-item": `section10_grid-item__rv+-6`,
	"grid-item1": `section10_grid-item1__C-yk+`,
	"grid-item2": `section10_grid-item2__iQ52p`,
	"grid-item3": `section10_grid-item3__HYmZC`,
	"grid-item4": `section10_grid-item4__eTpIG`,
	"grid-item5": `section10_grid-item5__PnOuJ`,
	"grid-item6": `section10_grid-item6__6RPE0`,
	"grid-item7": `section10_grid-item7__Fzqh7`
};
export default ___CSS_LOADER_EXPORT___;
